import React from "react";

import "./Footer.scss";

function Footer() {
  return (
    <div className="Footer">
      <div className="footer__wrapper container">
        <div className="f__lt">
          <h4>Free Of Gluten</h4>
          <p>
            Discover the joy of gluten-free living
            through our carefully curated selection of delicious and wholesome
            offerings, designed to support your healthy lifestyle
          </p>

          <div className="socials">
            <a href="https://www.instagram.com/freeofgluten_india"
              className="icon"
              target="_blank"
              rel="noreferrer"
            >
              <i class="fa-brands fa-instagram"></i>
            </a>

            <a href="https://wa.link/7vno4w"
              className="icon"
              target="_blank"
              rel="noreferrer"
            >
              <i class="fa-brands fa-whatsapp"></i>
            </a>

            <a href="https://www.linkedin.com/company/freeofgluten/"
              className="icon"
              target="_blank"
              rel="noreferrer"
            >
              <i class="fa-brands fa-linkedin"></i>
            </a>
          </div>
        </div>
        <div className="ft-rtt">
          <div className="f__md">
            <h4>Quick Links</h4>
            <ul>
              {/* {["Home", "About Us", "Reach", "Your Cart"].map(
                (item, id) => (
                  <li className="f-links" key={item - id}>
                    <a href={`/${item}`}>{item}</a>
                  </li>
                )
              )} */}
              <a href="/">
                <li className="f-links">Home</li>
              </a>
              <a href="/about">
                <li className="f-links">About us</li>
              </a>
              <a href="/reach">
                <li className="f-links">Reach us</li>
              </a>
              <a href="/shop">
                <li className="f-links">Shop</li>
              </a>
            </ul>
          </div>
          <div className="f__rt">
            <h4>Contact Us</h4>
            <div className="cont c-1">
              <span className="icon">
                <i class="fa fa-phone"></i>{" "}
              </span>
              <h5>9871119902</h5>
            </div>
            <div className="cont c-2">
              <span className="icon">
                <i class="fa-regular fa-envelope"></i>
              </span>
              <h5>contact@freeofgluten.in</h5>
            </div>
            <div className="cont c-3">
              <span className="icon">
                <i class="fa fa-location-dot"></i>{" "}
              </span>
              <h5>Satya Niketen, Delhi</h5>
            </div>
          </div>
        </div>

      </div>
      <div className="footer_copyright">Freeofgluten © -2023</div>
    </div>
  );
}

export default Footer;
